var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "align-items-center", attrs: { "no-gutters": "" } },
    [
      !_vm.areTagsEmpty
        ? _vm._l(_vm.tags, function (tag) {
            return _c(
              "b-badge",
              {
                key: tag.id,
                staticClass:
                  "ml-0 mr-2 mb-1 badge status-badge current-filter-badge",
                style: {
                  backgroundColor: tag.colour,
                  color: _vm.getReadableOppositeColor(tag.colour),
                },
              },
              [
                _vm._v("\n      " + _vm._s(tag.name) + "\n      "),
                _c(
                  "span",
                  {
                    staticClass: "ml-1 clickable",
                    on: {
                      click: function ($event) {
                        return _vm.removeLabel(tag)
                      },
                    },
                  },
                  [_c("icon", { attrs: { name: "times" } })],
                  1
                ),
              ]
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        { ref: "addTagsTarget", staticClass: "mb-1" },
        [
          _c("icon", {
            attrs: {
              name: "plus-square",
              "icon-class": "text-light-gray clickable",
            },
            on: {
              click: function ($event) {
                _vm.showingTagsSelector = true
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "tagsPopover",
          attrs: {
            target: _vm.addTagsTarget,
            triggers: "click focus",
            placement: "right",
            "custom-class": "w-50",
            boundary: "viewport",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.handleClickOutside,
                  expression: "handleClickOutside",
                },
              ],
              attrs: { id: "tags-popover-" + _vm.document.documentId },
            },
            [
              _c("document-tags-select", {
                attrs: {
                  "show-user-labels": _vm.showUserLabels,
                  "selected-labels": _vm.tags,
                  "select-dropdown-parent":
                    "#tags-popover-" + _vm.document.documentId,
                  disabled: _vm.disabledSelect,
                  loading: _vm.disabledSelect,
                },
                on: { change: _vm.handleSelect },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "d-flex align-items-center" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "pretty p-switch p-fill d-flex align-items-center justify-content-center mt-1 mr-0",
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.showUserLabels,
                          expression: "showUserLabels",
                        },
                      ],
                      attrs: { id: "show-labels-switch", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.showUserLabels)
                          ? _vm._i(_vm.showUserLabels, null) > -1
                          : _vm.showUserLabels,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.showUserLabels,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.showUserLabels = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.showUserLabels = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.showUserLabels = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "state" }, [
                      _c(
                        "label",
                        {
                          staticClass: "mb-0 ml-1 clickable",
                          style: { marginTop: "1px" },
                          attrs: { for: "show-labels-switch" },
                        },
                        [_vm._v(_vm._s(_vm.switchText))]
                      ),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }